import type { ReactNode } from 'react';
import { Box, IconButton, Paper, SwipeableDrawer } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type UpdateViewRoomModalType = {
  open: boolean;
  view: ReactNode;
  title: ReactNode;
  close: () => void;
};

const BottomDrawer = ({ title, open, view, close }: UpdateViewRoomModalType) => {
  return (
    <SwipeableDrawer
      className="SwipeableDrawerBox"
      anchor="bottom"
      open={open}
      onClose={close}
      onOpen={close}
      disableSwipeToOpen={true}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <Box className="SelectGroutColourHeader">
        {title}
        <Box className="CloseIcon">
          <IconButton onClick={close}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      <Paper className="AccountBox CommonDrawerBox">{view}</Paper>
    </SwipeableDrawer>
  );
};

export default BottomDrawer;
